import React from 'react';

import { DrawerSection } from '../constants/drawerSections';

export { default as SharedApprovalsDrawer } from './ApprovalsDrawer';
export { default as SharedFilesDrawer } from './FilesDrawer';

export function getDrawerContent(
  section: DrawerSection | null,
  components: Record<DrawerSection, React.ComponentType>,
): React.ReactNode {
  if (section == null) return null;
  const Component = components[section];
  return Component != null ? <Component /> : null;
}
